import { apiClient } from '../client';

/** SU-8 (W7): GET /api/admin/platform/health (super admin, read only). */

type Section<T> = ({ available: true } & T) | { available: false };
export type HealthCarrier = 'twilio' | 'asterisk' | 'zadarma';

export interface HealthException {
  id: string;
  severity: 'warning' | 'critical';
  kind: 'outbox_dead' | 'outbox_failed' | 'outbox_stale' | 'carrier_failures' | 'qualifications_overdue' | 'qualifications_failed' | 'webhook_events_lost' | 'webhooks_failed' | 'client_errors_spike' | 'section_unavailable';
  values: Record<string, string | number>;
  link: string | null;
}

export interface PlatformHealth {
  generated_at: string;
  period_hours: number;
  outbox: Section<{ pending: number; failed: number; dead: number; oldest_pending_at: string | null }>;
  carriers: Section<{ rows: Array<{ carrier: HealthCarrier; calls: number; failed: number; failure_rate: number | null }> }>;
  sse: Section<{ dialer: number; transcript: number; total: number }>;
  qualifications: Section<{ pending: number; committing: number; overdue: number; failed_24h: number; failed_total: number; events_lost_24h?: number }>;
  webhooks: Section<{ pending: number; failed: number; delivered: number; other: number }>;
  client_errors: Section<{ last_24h: number }>;
  exceptions: HealthException[];
  thresholds: Record<string, number>;
}

export function getPlatformHealth(signal?: AbortSignal) {
  return apiClient.get<PlatformHealth>('/admin/platform/health', { signal });
}
